"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "messages" };
const _hoisted_2 = {
    key: 0,
    class: "mx-2 mb-2 font-xsm"
};
const _hoisted_3 = {
    key: 0,
    class: "message-text"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 2,
    class: "file-chip"
};
const _hoisted_6 = { class: "file-name" };
const _hoisted_7 = {
    key: 3,
    class: "oplus-delete-text mt-1"
};
const _hoisted_8 = {
    key: 1,
    class: "chat-message user-message font-sm"
};
const _hoisted_9 = {
    key: 0,
    class: "message-text"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
    key: 2,
    class: "message-text"
};
const _hoisted_12 = {
    key: 3,
    class: "file-chip"
};
const _hoisted_13 = {
    key: 2,
    class: "reply-status font-sm"
};
const _hoisted_14 = {
    key: 3,
    class: "next-step-cont"
};
const _hoisted_15 = { class: "next-step-actions" };
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIAgentMessages',
    props: {
        historyMessages: {},
        pendingMessage: {},
        showReplyStatus: { type: Boolean },
        showNextStepActions: { type: Boolean }
    },
    emits: ["use-prompt", "modify-prompt"],
    setup(__props) {
        function hasRawMessageContent(message) {
            return (message.MessageRaw?.trim().length ?? 0) > 0;
        }
        function hasFormattedMessageContent(message) {
            if (!message.Message) {
                return false;
            }
            const parsedDocument = new DOMParser().parseFromString(message.Message, 'text/html');
            return (parsedDocument.body.textContent || '').trim().length > 0;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (__props.historyMessages.length === 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
                            (0, vue_2.createTextVNode)(" こんにちは。", -1 /* CACHED */),
                            (0, vue_2.createElementVNode)("br", null, null, -1 /* CACHED */),
                            (0, vue_2.createTextVNode)(" AIを活用したシフト作成をお手伝いします。", -1 /* CACHED */),
                            (0, vue_2.createElementVNode)("br", null, null, -1 /* CACHED */),
                            (0, vue_2.createTextVNode)(" まず、現在のシフト表のサンプルとなるExcel（またはCSV）ファイルをアップロードしてください。シフトのパターンを分析します。 ", -1 /* CACHED */)
                        ]))]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.historyMessages, (message, index) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: index,
                        class: (0, vue_2.normalizeClass)(["chat-message font-sm", { 'user-message': !message.isAgent }])
                    }, [
                        (hasRawMessageContent(message))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)(message.MessageRaw), 1 /* TEXT */))
                            : (hasFormattedMessageContent(message))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 1,
                                    class: "message-text formatted-message",
                                    innerHTML: message.Message
                                }, null, 8 /* PROPS */, _hoisted_4))
                                : (0, vue_2.createCommentVNode)("v-if", true),
                        (message.filename)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                (0, vue_2.createElementVNode)("span", _hoisted_6, (0, vue_2.toDisplayString)(message.filename), 1 /* TEXT */)
                            ]))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (message.fileWarning)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, (0, vue_2.toDisplayString)(message.fileWarning), 1 /* TEXT */))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 2 /* CLASS */));
                }), 128 /* KEYED_FRAGMENT */)),
                (__props.pendingMessage)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_8, [
                        (hasRawMessageContent(__props.pendingMessage))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)(__props.pendingMessage.MessageRaw), 1 /* TEXT */))
                            : (hasFormattedMessageContent(__props.pendingMessage))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: 1,
                                    class: "message-text formatted-message",
                                    innerHTML: __props.pendingMessage.Message
                                }, null, 8 /* PROPS */, _hoisted_10))
                                : (__props.pendingMessage.text)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, (0, vue_2.toDisplayString)(__props.pendingMessage.text), 1 /* TEXT */))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                        (__props.pendingMessage.fileName)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, (0, vue_2.toDisplayString)(__props.pendingMessage.fileName), 1 /* TEXT */))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.showReplyStatus)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, " シフトエージェントが回答を作成しています... "))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (__props.showNextStepActions)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("div", { class: "font-xsm" }, [
                            (0, vue_2.createTextVNode)(" どのように進めますか？"),
                            (0, vue_2.createElementVNode)("br"),
                            (0, vue_2.createTextVNode)(" 上記のルールをコピーしてシフト作成に使用することもできます。また、ルールを変更することもできます。 ")
                        ], -1 /* CACHED */)),
                        (0, vue_2.createElementVNode)("div", _hoisted_15, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "next-step-btn",
                                type: "button",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('use-prompt')))
                            }, " このルールを使用 "),
                            (0, vue_2.createElementVNode)("button", {
                                class: "next-step-btn",
                                type: "button",
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('modify-prompt')))
                            }, " ルールを変更 ")
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ]));
        };
    }
});
